import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { BrainCircuit, TrendingUp, BarChart3 } from 'lucide-react';
const pillars = [{
  icon: BrainCircuit,
  title: 'Inteligencia Artificial',
  description: 'Automatiza la ejecución. Crea activos digitales y servicios de alta demanda en minutos, no horas.'
}, {
  icon: TrendingUp,
  title: 'Ventas Digitales',
  description: 'El motor de cashflow. Domina el arte de cerrar tratos de alto valor con scripts optimizados por IA.'
}, {
  icon: BarChart3,
  title: 'Trading e Inversión',
  description: 'Multiplica el capital. Gestión de riesgo profesional y estrategias de alta probabilidad para hacer crecer tu flujo.'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 30
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: [0.16, 1, 0.3, 1]
    }
  }
};
export function Pillars() {
  return <section className="py-12 relative z-10" data-id="element-80">
      <div className="max-w-7xl mx-auto px-6" data-id="element-81">
        <div className="text-center mb-16" data-id="element-82">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} className="font-display text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-83">
            El Stack de la Nueva Economía
          </motion.h2>
          <motion.div initial={{
          scaleX: 0
        }} whileInView={{
          scaleX: 1
        }} viewport={{
          once: true
        }} className="h-1 w-24 bg-brand-cyan mx-auto rounded-full" data-id="element-84" />
        </div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-85">
          {pillars.map((pillar, index) => <motion.div key={index} variants={itemVariants} className="glass-card glass-card-hover p-8 rounded-2xl group relative overflow-hidden" data-id="element-86">
              <div className="absolute top-0 right-0 w-32 h-32 bg-brand-cyan/10 rounded-full blur-3xl -mr-10 -mt-10 transition-all duration-500 group-hover:bg-brand-cyan/20" data-id="element-87" />

              <div className="w-14 h-14 rounded-xl bg-brand-cyan/10 border border-brand-cyan/20 flex items-center justify-center mb-6 relative z-10 group-hover:scale-110 transition-transform duration-300" data-id="element-88">
                <pillar.icon className="w-7 h-7 text-brand-cyan" data-id="element-89" />
              </div>

              <h3 className="font-display text-xl font-bold text-white mb-3 relative z-10" data-id="element-90">
                {pillar.title}
              </h3>

              <p className="text-white/60 leading-relaxed relative z-10" data-id="element-91">
                {pillar.description}
              </p>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}